<template>
  <div class="page-wrapper">
    <div class="page-content">
      <div class="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
        <div class="breadcrumb-title pe-3">Home About Dispensary CMS</div>
        <div class="ps-3">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb mb-0 p-0">
              <li class="breadcrumb-item">
                <router-link to="/">
                  <i class="bx bx-home-alt"></i>
                </router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Home About Dispensary CMS
              </li>
            </ol>
          </nav>
        </div>
      </div>
      <form @submit.prevent="updateCms()">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Home About Dispensary CMS</h5>
            <hr />
            <div class="form-body mt-4">
              <div class="row">
                <div class="col-lg-8 mb-3">
                  <div class="border border-3 p-4 rounded">
                    <div class="row">
                      <div class="col-12 mb-3">
                        <label class="form-label">Description:</label>
                        <ckeditor
                          :editor="editor"
                          v-model="cmsData.description"
                          :config="editorConfig"
                        ></ckeditor>
                      </div>
                      <div class="col-12 mb-3">
                        <div class="row">
                          <div class="col-12">
                            <label for="inputProductTitle" class="form-label">
                              Image:
                              <strong
                                >[Preferred Image Size: 561X599, Max Upload
                                Limit: 1MB]</strong
                              >
                            </label>
                          </div>
                          <div class="col-12">
                            <input
                              class="form-control mt-3"
                              type="file"
                              ref="backgroundImage1"
                              accept="image/*"
                              @change="
                                handleUploadImage(
                                  'image',
                                  'imageOne',
                                  'backgroundImage1',
                                  $event
                                )
                              "
                            />
                          </div>
                        </div>
                        <div class="mt-3">
                          <img
                            style="position: relative; left: 11px"
                            v-if="preview.imageOne"
                            :src="preview.imageOne"
                            height="100"
                          />
                          <img
                            style="position: relative; left: 11px"
                            v-else-if="cmsData.image"
                            :src="cmsData.image"
                            height="100"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-grid col-lg-8">
                  <button type="submit" class="btn btn-primary">Save</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script src="../js/home-v2-about-dispensary-cms.js"></script>
